export const containerClassName = 'py-8px px-2px border-b-[5px] mb-8px'

export const rightElementContainerClassName = 'flex items-center ml-1'

export const escContainerClassName = 'py-2px px-4px border rounded'
